import { apiExternal } from '../../config';

const errors = {
  401: 'api_error_unauthorized',
  404: 'api_error_route_not_found',
  400: 'api_error_cost_referential_unkown',
  405: 'api_error_cost_referential_unkown',
  500: 'api_error_internal_error',
};

export default async function getReferentialUpdateDate(referentialName, token) {
  const headers = {
    Authorization: `Bearer ${token}`,
  };
  const query = `?referentialId=${referentialName}`;
  const { url, method, path } = apiExternal.getReferentialUpdateDate;
  const response = await fetch(url + path + query, { headers, method });

  if (response.status in errors) throw new Error(errors[response.status]);
  if (response.status > 299) throw new Error('api_error_internal_error');
  try {
    const referentialUpdateDate = await response.json();
    return referentialUpdateDate;
  } catch (e) {
    console.log('error ref', referentialName); // eslint-disable-line no-console
  }
  return true;
}
